import React from 'react'
import { useRoutes as routerUseRoutes, type RouteObject } from 'react-router-dom'
import { BrowserLanguageDetector } from '../components/localization/browser-language-detector'
import FormPage from '../pages/form'
import RepairKitPage from '../pages/repair-kit'
import SimondInfoPage from '../campaigns/simond-quickdraw/info-page'
import SimondProcedurePage from '../campaigns/simond-quickdraw/procedure-page'
import SimondOutcomePage from '../campaigns/simond-quickdraw/outcome-page'
import { campaign } from '../campaigns'

/**
 * Routes for campaigns that run the shared multi-step wizard.
 */
const wizardRoutes: RouteObject[] = [
  //{ path: '/:lang/recall-status/:serialNumber', element: <RecallStatusPage /> },
  { path: '/repair-kit', element: <BrowserLanguageDetector redirectTo="repair-kit" /> },
  { path: '/form', element: <BrowserLanguageDetector /> },
  { path: '/:lang/repair-kit', element: <RepairKitPage /> },
  { path: '/:lang', element: <FormPage /> },
  { path: '/:lang/form', element: <FormPage /> },
  { path: '/', element: <BrowserLanguageDetector /> },
]

/**
 * Routes for the Simond quickdraw recall.
 *
 * Three screens rather than a wizard: the remedy is a store return, so there is
 * no quantity step, repair kit or delivery form. The inspection result is part
 * of the outcome URL so a reload still shows the right advice.
 */
const simondRoutes: RouteObject[] = [
  { path: '/:lang', element: <SimondInfoPage /> },
  { path: '/:lang/check', element: <SimondProcedurePage /> },
  { path: '/:lang/result/:outcome', element: <SimondOutcomePage /> },
  { path: '/', element: <BrowserLanguageDetector /> },
]

const routesByCampaign: Record<string, RouteObject[]> = {
  'simond-quickdraw': simondRoutes,
}

const useRoute = (): React.ReactElement | null =>
  routerUseRoutes(routesByCampaign[campaign.slug] ?? wizardRoutes)

export default useRoute
